import * as REGEXP from './regexp';
import * as methods from './methods';

export default {
	REGEXP,
	...methods,
};
